import { Bowser } from '@factorin/util';

import { oids } from './oids';


export const subjectNameTagsTranslations = [
    { possibleNames: ['UnstructuredName'], translation: 'Неструктурированное имя' },
    { possibleNames: ['CN'], translation: 'Владелец' },
    { possibleNames: ['SN'], translation: 'Фамилия' },
    { possibleNames: ['G'], translation: 'Имя Отчество' },
    { possibleNames: ['C'], translation: 'Страна' },
    { possibleNames: ['S'], translation: 'Регион' },
    { possibleNames: ['STREET'], translation: 'Адрес' },
    { possibleNames: ['O'], translation: 'Компания' },
    { possibleNames: ['OU'], translation: 'Отдел/подразделение' },
    { possibleNames: ['T'], translation: 'Должность' },
    { possibleNames: ['ОГРН', 'OGRN'], translation: 'ОГРН' },
    { possibleNames: ['ОГРНИП', 'OGRNIP'], translation: 'ОГРНИП' },
    { possibleNames: ['СНИЛС', 'SNILS'], translation: 'СНИЛС' },
    { possibleNames: ['ИНН', 'INN'], translation: 'ИНН' },
    { possibleNames: ['ИНН ЮЛ', 'ЮЛ', 'INNLE'], translation: 'ИНН ЮЛ' },
    { possibleNames: ['Тип идентификации при выдаче сертификата', 'IdentificationKind'], translation: 'Тип идентификации при выдаче сертификата' },
    { possibleNames: ['E'], translation: 'Email' },
    { possibleNames: ['L'], translation: 'Город' },
];

export const issuerNameTagsTranslations = [
    { possibleNames: ['UnstructuredName'], translation: 'Неструктурированное имя' },
    { possibleNames: ['CN'], translation: 'Удостоверяющий центр' },
    { possibleNames: ['S'], translation: 'Регион' },
    { possibleNames: ['C'], translation: 'Страна' },
    { possibleNames: ['STREET'], translation: 'Адрес' },
    { possibleNames: ['O'], translation: 'Компания' },
    { possibleNames: ['OU'], translation: 'Тип' },
    { possibleNames: ['T'], translation: 'Должность' },
    { possibleNames: ['ОГРН', 'OGRN'], translation: 'ОГРН' },
    { possibleNames: ['ОГРНИП', 'OGRNIP'], translation: 'ОГРНИП' },
    { possibleNames: ['СНИЛС', 'SNILS'], translation: 'СНИЛС' },
    { possibleNames: ['ИНН', 'INN'], translation: 'ИНН' },
    { possibleNames: ['ИНН ЮЛ', 'ЮЛ', 'INNLE'], translation: 'ИНН ЮЛ' },
    { possibleNames: ['Тип идентификации при выдаче сертификата', 'IdentificationKind'], translation: 'Тип идентификации при выдаче сертификата' },
    { possibleNames: ['E'], translation: 'Email' },
    { possibleNames: ['L'], translation: 'Город' },
];

const regexes = {
    infoString: /([а-яА-Яa-zA-Z0-9.]+)=(?:("[^"]+?")|(.+?))(?:,|$)/g,
    group: /^([а-яА-Яa-zA-Z0-9.]+)=(.+?),?$/,
    oid: {
        test: /^OID./,
        match: /^OID\.(.*)/,
    },
    quotes: {
        first: /^"(.*)"/,
        second: /"{2}/g,
    },
};

const parseGroup = tags => group => {
    const parts = group.match(regexes.group);
    let title = parts && parts[1];
    let descr = parts && parts[2];
    let translated = false;

    if (regexes.oid.test.test(title)) {
        let oidTitle = title.match(regexes.oid.match);

        if (oidTitle && oidTitle[1]) {
            oidTitle = oids[oidTitle[1]];

            if (oidTitle)
                title = oidTitle;
        }
    }

    descr = descr.replace(regexes.quotes.first, '$1');
    descr = descr.replace(regexes.quotes.second, '"');

    tags.some(tag => tag.possibleNames.some(possible => {
        const match = possible === title;

        if (match) {
            title = tag.translation;
            translated = true;
        }

        return match;
    }));

    return {
        title,
        descr,
        translated,
    };
};

export const parseCertInfo = (tags, infoString) => {
    let result = infoString.match(regexes.infoString);

    if (result)
        result = result.map(parseGroup(tags));

    return result;
};

const bowser = new Bowser();

export const getDateObj = dateObj =>
    bowser.ie ? dateObj.getVarDate() : dateObj;
